import React from "react";
import styles from "./index.module.scss";

interface FilterValueItem {
  value: string;
  label: string;
}

interface FilterValue {
  label: string;
  value: Array<FilterValueItem> | {
    startDate?: string;
    endDate?: string;
    operator?: string;
    value?: string;
  };
}

interface AppliedFilters {
  [key: string]: FilterValue;
}

type FilterPillsProps = {
  appliedFilters: AppliedFilters;
  totalData: number;
  handleRemoveFilter: (key: string, val: string) => void;
  handleClearAllFilters: () => void;
  onMoreClick?: () => void;
};

type FilterPill = {
  key: string;
  val: string;
  label: string;
};

const FilterPills: React.FC<FilterPillsProps> = ({
  appliedFilters,
  totalData,
  handleRemoveFilter,
  handleClearAllFilters,
  onMoreClick,
}) => {
  if (!appliedFilters || Object.keys(appliedFilters).length === 0) return null;
  // Flatten all pills for counting and rendering
  const allPills: FilterPill[] = [];
  Object.entries(appliedFilters).forEach(([key, filterData]) => {
    const { label, value } = filterData;

    if (key === "dateRange" && typeof value === "object" && "startDate" in value) {
      allPills.push({
        key: "dateRange",
        label: label || "Date Range",
        val: `${value.startDate} - ${value.endDate}`,
      });
    } else if (Array.isArray(value)) {
      // Handle array of objects with value and label
      value.forEach((item: FilterValueItem) => {
        allPills.push({ 
          key, 
          label: label || key,
          val: item.label || item.value // Use item label if available
        });
      });
    } else if (typeof value === "object" && "operator" in value) {
      allPills.push({
        key,
        label: label || key,
        val: `${value.operator} ${value.value}`
      });
    }
  });

  const pillsToShow = allPills.slice(0, 3);
  const pillsHiddenCount = allPills.length - 3;

  // Custom remove handler for dateRange
  const handleRemove = (key: string, val: string) => {
    // Handle both key === "dateRange" and key === "" (for date range pill)
    if (key === "dateRange" || (key === "" && val && val.includes(" - "))) {
      handleRemoveFilter("dateRange", "");
    } else {
      handleRemoveFilter(key, val);
    }
  };

  return (
    <div className={styles.filterPillContainer}>
      {/* <span className={styles.divider}>|</span> */}
      <span className={styles.filtersLabel}>Filters applied:</span>
      {pillsToShow.map(({ key, val, label }, idx) => (
        <span key={`${key}-${idx}`} className={styles.filterPill}>
          {label}: {val}
          <button
            className={styles.removeFilterBtn}
            onClick={() => handleRemove(key, val)}
          >
            ×
          </button>
        </span>
      ))}
      {pillsHiddenCount > 0 && (
        <span
          className={styles.morePills}
          style={{ cursor: "pointer" }}
          onClick={onMoreClick}
        >
          +{pillsHiddenCount} more
        </span>
      )}
      <button className={styles.clearAllBtn} onClick={handleClearAllFilters}>
        clear all
      </button>
      <span className={styles.divider}>|</span>
    </div>
  );
};

export default FilterPills;